import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeUrlPipe } from 'src/app/core/pipes/safe-url.pipe';
import { NoDecimalDirective } from '../directive/no-decimal.directives';
import { RestrictCombinationDirective } from '../directive/restrict-combination.directives';
import { AutoResizeObserverDirective } from '../directive/resize.directives';
import { NoLeadingZeroDatePipe } from '../directive/no-leading-zero-dates.directives';

@NgModule({
  declarations: [
    SafeUrlPipe,
    NoDecimalDirective,
    RestrictCombinationDirective,
    AutoResizeObserverDirective,
    NoLeadingZeroDatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafeUrlPipe,
    NoDecimalDirective,
    RestrictCombinationDirective,
    AutoResizeObserverDirective,
    NoLeadingZeroDatePipe
  ]
})
export class SharedModule { }
